import listingAdapter from '@/features/listing/requests/adapters/listing-adapter';
import { type ListingWithUser } from '@/features/listing/types/listing-types';
import {
  type ListingResponse,
  type ListingsMapPreviewResponse,
} from '@/features/listing/types/listings-search-response-types';
import userAdapter from '@/features/user/requests/adapters/user-adapter';
import { type UserResponse } from '@/features/user/types/user-response-types';
import sendHttpError from '@/libs/logger/requests/send-http-error';

export default async function getMapPreviewListings(
  listingsIds: number[],
  currentCurrencyName: string,
  isMultipleListings = false,
): Promise<ListingWithUser[]> {
  // id need to make request, in such way was developed endpoint
  const listingId = String(listingsIds[0]);
  const queryParams = new URLSearchParams({ include_user_data: 'true' });
  const headers: HeadersInit = { Currency: currentCurrencyName };

  if (isMultipleListings) {
    queryParams.set('listing_ids', listingsIds.join(','));
  }

  const url = `${process.env.NEXT_PUBLIC_API_URL}/v1/listings/${listingId}?${queryParams.toString()}`;

  const mapListingsResponse = await fetch(url, {
    cache: 'no-store',
    headers,
  });

  if (!mapListingsResponse.ok) {
    sendHttpError({
      baseName: 'Get listings for map marker preview',
      functionName: 'getMapPreviewListings',
      method: 'GET',
      requestHeaders: headers,
      statusCode: mapListingsResponse.status,
      url,
    });

    throw new Error('Failed to fetch data');
  }

  const mapListingsData = await mapListingsResponse.json() as ListingsMapPreviewResponse[];

  if (isMultipleListings) {
    return mapListingsData.map((listing) => ({
      ...listingAdapter(listing),
      user: userAdapter(listing.user),
    }));
  }
  // @ts-expect-error - need to change types for ListingsMapPreviewResponse because on single id request APi return object
  return [{ ...listingAdapter(mapListingsData as ListingResponse), user: userAdapter(mapListingsData.user as UserResponse) }];
}
